import { Modal } from "antd";
import styled, { css } from "styled-components";

interface IBundlesOverlayContainerProps {
  themeBuyButtonsOption: string;
  customButtonColor: string;
}

export const BundlesOverlayContainer = styled(
  Modal,
)<IBundlesOverlayContainerProps>`
  .ant-modal-close {
    top: 15px;
    right: 5px;
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      .ant-modal-content {
        background: #303030 !important;
      }

      button.ant-modal-close {
        .ant-modal-close-x {
          svg {
            line {
              color: #717171;
            }
          }
        }
      }

      .ant-modal-body {
        background: #303030 !important;

        .individual-sale-card,
        .plans-container > div {
          background: #282828 !important;
        }

        .option-card {
          background: #303030;

          h5,
          div {
            color: #ffffff !important;
          }
        }

        h2,
        h3,
        p,
        span {
          color: #ffffff;
        }

        button {
          color: #1a1a1a;
        }
      }
    `}

  .ant-modal-body {
    width: 100%;
    display: flex;
    padding: 60px;
    margin: 80px 0 60px;
    align-items: center;
    background: #f5f5f5;
    border-radius: 13px;
    flex-direction: column;

    & > h2 {
      font-size: 26px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 45px;
    }

    .individual-sale-card {
      display: flex;
      padding: 25px;
      width: 100%;
      max-width: 300px;
      background: #fff;
      position: relative;
      align-items: center;
      border-radius: 13px;
      margin-bottom: 45px;
      flex-direction: column;
      box-shadow: 1px 15px 60px rgba(0, 0, 0, 0.08);

      h3 {
        font-size: 22px;
        text-align: center;
        margin-bottom: 20px;

        .price {
          font-weight: 500;
          letter-spacing: -1px;
        }
      }

      .buy-btn {
        width: 100%;
        margin: 0;
        border: unset;
        color: ${({ theme }) => theme.colors.btnTextColor} !important;
        background-color: ${({ theme }) => theme.colors.primary} !important;
      }

      ${({ themeBuyButtonsOption, customButtonColor, theme }) =>
        themeBuyButtonsOption !== "automatic" &&
        css`
          .buy-btn {
            background-color: ${customButtonColor} !important;
            border-color: ${customButtonColor} !important;
            color: ${theme.colors.btnTextColor} !important;

            &:hover {
              opacity: 0.8;
              color: ${({ theme }) => theme.colors.btnTextColor} !important;
            }
          }
        `}

      p {
        margin: 0;
        font-size: 15px;
        margin-top: 20px;
        text-align: center;
      }
    }

    & > h3 {
      font-size: 22px;
      text-align: center;
      margin-bottom: 50px;
    }

    .plans-container {
      width: 100%;
      display: flex;
      grid-gap: 40px;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  ${({ themeBuyButtonsOption }) =>
    themeBuyButtonsOption !== "automatic" &&
    css<IBundlesOverlayContainerProps>`
      .buy-btn {
        background-color: ${({ customButtonColor }) =>
          customButtonColor} !important;
        border-color: ${({ customButtonColor }) =>
          customButtonColor} !important;
      }
    `}

  @media screen and (max-width: 768px) {
    .ant-modal-body {
      padding: 60px 30px;
      margin: 40px 0 20px;
    }
  }

  @media screen and (max-width: 480px) {
    .ant-modal-body {
      max-width: 400px;
    }
  }
`;
